import {
	I18nFormDrawer,
	I18nFormDrawerContent,
	I18nOnlyOnMainForm,
	I18nTextField,
	Id,
	TextField,
	validateEachLanguage,
} from "@dgs/core";
import { FC, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { PreferenceSelect } from "../preferences/PreferenceSelect";
import { PreferenceFormValues, PreferenceTranslationEntry } from "../shared/types/preference";

interface Props {
	heading: string;
	open: boolean;
	onSubmit: (preference: PreferenceFormValues) => Promise<false | Id>;
	handleClose: () => void;
	initialValues: PreferenceFormValues;
}

export const PreferenceDrawer: FC<Props> = ({ open, onSubmit, handleClose, initialValues, heading }) => {
	const { t } = useTranslation();

	const validate = useCallback(
		(values: PreferenceFormValues) => {
			const errors: { [K in keyof PreferenceFormValues]?: any } = {};

			if (!values.name) {
				errors.name = t("Required field");
			}

			return {
				...errors,
				...validateEachLanguage(values.translations, (_, values) => {
					const errors: { [K in keyof PreferenceTranslationEntry]?: any } = {};

					if (!values.label) {
						errors.label = t("Required field");
					}

					return errors;
				}),
			};
		},
		[t],
	);
	const handleSubmit = async (values: PreferenceFormValues) => {
		const result = await onSubmit(values);

		if (result) {
			handleClose();
		}

		return result;
	};

	return (
		<I18nFormDrawer
			renderForm={(props) => (
				<I18nFormDrawerContent {...props} emptyTranslation={{ label: "" }}>
					<I18nOnlyOnMainForm>
						<TextField name="name" label={t("Name")} required />
					</I18nOnlyOnMainForm>
					<I18nTextField name="label" label={t("Label")} required="onlyOnMainForm" />
					<I18nOnlyOnMainForm>
						<PreferenceSelect name="parentId" label={t("Parent preference")} preferenceId={initialValues.id} />
					</I18nOnlyOnMainForm>
				</I18nFormDrawerContent>
			)}
			validate={validate}
			title={heading}
			initialValues={initialValues}
			open={open}
			onClose={handleClose}
			onSubmit={handleSubmit}
		/>
	);
};
